module.exports = __webpack_public_path__ + "static/media/mouse.3effda2d.svg";